import { classNames } from "@/react/helpers/twMergeWithCN";

import type { SpaceGroupWithSpaces } from "../Sidebar";
import { SpaceGroupName } from "./CommunityMenu/SpaceGroupList/SpaceGroupName";
import { SpaceGroupViewWrapper } from "./CommunityMenu/SpaceGroupList/SpaceGroupViewWrapper";
import { BottomButton } from "./CommunityMenu/SpaceList/BottomButton";
import { SpaceListView } from "./CommunityMenu/SpaceList/SpaceListView";
import { SpaceView } from "./CommunityMenu/SpaceList/SpaceView";

interface SpaceGroupDragOverlayProps {
  className?: string;
  spaceGroup: SpaceGroupWithSpaces;
}

export function SpaceGroupDragOverlay({
  spaceGroup,
  className,
}: SpaceGroupDragOverlayProps) {
  const { spaces } = spaceGroup;
  const hasSpaces = spaces.length > 0;

  return (
    <div
      id={spaceGroup.slug}
      className={classNames("group relative", className)}
    >
      <SpaceGroupViewWrapper className="rounded-lg bg-c-sidebar-hover shadow-lg">
        <SpaceGroupName
          canManage={false}
          isCollapsed={false}
          isDropdownOpen={false}
          spaceGroup={spaceGroup}
        />
      </SpaceGroupViewWrapper>
      <div className="opacity-0 bg-transparent pointer-events-none">
        <SpaceListView>
          {hasSpaces ? (
            spaceGroup.spaces.map(space => (
              <SpaceView key={space.id} space={space} isDragOverlay />
            ))
          ) : (
            <BottomButton spaceGroup={spaceGroup} />
          )}
        </SpaceListView>
      </div>
    </div>
  );
}
